import { Alert, AlertStatus } from '@/gen/inventory/v1/alert_pb'

/**
 * Open and Ongoing are the "needs attention" statuses surfaced in tab/header badges —
 * Resolved / Accepted / Not applicable items are filtered out of those counts.
 */
export const isOpenOrOngoing = (status: AlertStatus | undefined): boolean =>
  status === AlertStatus.OPEN || status === AlertStatus.ONGOING

export const countOpenOrOngoingAlerts = (alerts: readonly Alert[]): number =>
  alerts.filter((a) => isOpenOrOngoing(a.workStatus)).length
